<template>
  <form class="contact-person__form tw-w-full" @submit.prevent="submitData">
    <div class="tw-flex tw-flex-col">
      <div class="md:tw-flex tw-justify-between sm:tw-block">
        <OnboardingNameInput
          class="contact-person__input"
          placeHolder="First name"
          label="First name"
          :name="payload.firstName"
          :error="firstNameError || {}"
          inputName="firstName"
          @set="setValue"
          @validate="validateMethod"
        />
        <OnboardingNameInput
          class="tw-mt-6 md:tw-mt-0 contact-person__input"
          placeHolder="Last name"
          label="Last name"
          :name="payload.lastName"
          :error="lastNameError || {}"
          inputName="lastName"
          @set="setValue"
          @validate="validateMethod"
        />
      </div>
      <p class="tw-text-gray tw-text-xs tw-mt-1">
        This name must correspond to the name on your ID
      </p>
    </div>
    <div class="tw-mt-4">
      <OnboardingEmailInput
        placeHolder="Enter email address"
        label="Email address"
        :email="payload.email"
        :error="emailError || {}"
        :disabled="loading"
        @set="setEmail"
        @validate="validateMethod"
      />
    </div>
    <OnboardingBtn :loading="loading" title="Continue" />
  </form>
</template>

<script>
import { mapState, mapActions } from "vuex";
import useValidate from "@vuelidate/core";
import { required, email } from "@vuelidate/validators";
import OnboardingNameInput from "@/components/onboarding/OnboardingNameInput.vue";
import OnboardingEmailInput from "@/components/onboarding/OnboardingEmailInput.vue";
import OnboardingBtn from "@/components/onboarding/OnboardingBtn.vue";

export default {
  name: "ContactPersonForm",

  components: {
    OnboardingNameInput,
    OnboardingBtn,
    OnboardingEmailInput,
  },

  emits: ["submit-data"],

  data() {
    return {
      v$: useValidate(),
      payload: {
        firstName: "",
        lastName: "",
        email: "",
      },
      firstNameError: {},
      lastNameError: {},
      emailError: {},
    };
  },

  validations() {
    return {
      payload: {
        firstName: { required },
        lastName: { required },
        email: { required, email },
      },
    };
  },

  computed: {
    ...mapState({
      loading: (state) => state.loadingModule.contactPersonLoading,
      success: (state) => state.loadingModule.contactPersonSuccess,
    }),
  },

  methods: {
    ...mapActions("loadingModule", ["contactPersonSuccess"]),

    submitData() {
      this.v$.$validate();
      const hasValue = Object.keys(this.payload).every(
        (key) => this.payload[key]
      );
      if (this.v$.$errors.length === 0 && hasValue) {
        this.$emit("submit-data", this.payload);
      }
    },
    setValue(obj) {
      this.payload[obj.inputName] = obj.name;
    },

    setFirstName(details) {
      this.payload.firstName = details.name;
    },

    setLastName(details) {
      this.payload.lastName = details.name;
    },

    setEmail(email) {
      this.payload.email = email;
    },

    validateMethod(field) {
      switch (field) {
        case "First name":
          this.v$.$reset();
          this.v$.payload.firstName.$touch();
          if (this.v$.$errors.length === 0) return (this.firstNameError = {});
          this.firstNameError = this.v$.$errors[0];
          break;

        case "Last name":
          this.v$.$reset();
          this.v$.payload.lastName.$touch();
          if (this.v$.$errors.length === 0) return (this.lastNameError = {});
          this.lastNameError = this.v$.$errors[0];
          break;

        case "Enter email address":
          this.v$.$reset();
          this.v$.payload.email.$touch();
          if (this.v$.$errors.length === 0) return (this.emailError = {});
          this.emailError = this.v$.$errors[0];
          break;

        default:
          break;
      }
    },
  },

  watch: {
    success(newValue) {
      if (newValue === true) {
        this.payload = {
          firstName: "",
          lastName: "",
          email: "",
          role: "",
        };
        this.contactPersonSuccess(false);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.contact-person {
  @media (min-width: 768px) {
    &__form {
      width: 440px;
    }
    &__input {
      width: 209px;
    }
  }
}
</style>
